import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading4, ButtonLink, Icon } from '@blueprint/ui';

export const Content = styled('div')(
    ({ theme: { spacing, mq } }) => css`
        text-align: center;
        padding: ${spacing['32px']} 0 ${spacing['16px']} 0;

        ${mq.small} {
            padding: 0 ${spacing['48px']} ${spacing['16px']} ${spacing['48px']};
        }
    `
);

export const StyledHeading = styled(Heading4)(
    ({ theme: { spacing, mq } }) => css`
        margin: ${spacing['24px']} 0 ${spacing['16px']} 0;

        ${mq.small} {
            margin: ${spacing['16px']} 0;
        }
    `
);

export const StyledButtonLink = styled(ButtonLink)(
    ({ theme: { spacing } }) => css`
        display: block;
        margin: ${spacing['32px']} 0;
    `
);

export const StyledIcon = styled(Icon)(
    ({ theme: { spacing } }) => css`
        margin-right: ${spacing['8px']};
        vertical-align: top;
    `
);

export const StyledImage = styled('img')(css`
    height: 87px;
`);
